import { ReactComponent as IconDataElement } from '@/assets/svgs/data-element-grey.svg';
import Button from '@/components/Button/index';
import { useState } from 'react';
import { useNavigate, useLocation } from '@/lib/router-dom';

export default function TemplateCard({ item }) {
	const { goTo } = useNavigate();
	const [showMore, setShowMore] = useState(false)

	return (
		<div className="eclip-landing_template-card">
			<div
				className="eclip-landing__template-card__banner trim--three-lines"
				style={{ backgroundImage: `url(/svgs/template-banner.svg)` }}
			>
				{item.name}
			</div>
			<div className="eclip-landing__template-card__list">
				{(showMore ? item.dataElements : item.dataElements?.slice(0, 4))?.map(
				(cert, index) => {
					return (
						<div className="eclip-landing__template-card__list-item" key={index}>
							<IconDataElement /> <span>{cert.elementName}</span>
						</div>
					)
				},
				)}

				{item?.dataElements?.length > 4 && (
				<div className="eclip-landing__template-card__list-item">
					{showMore ? (
					<span
						className="click-more-items"
						onClick={() => {
						setShowMore(false)
						}}
					>
						Hide
					</span>
					) : (
					<span
						className="click-more-items"
						onClick={() => {
						setShowMore(true)
						}}
					>
						+{item?.dataElements?.length - 4} more Data Elements
					</span>
					)}
				</div>
				)}
			</div>

			<div className="eclip-landing__template-card__footer-item">

			{/* <Button
				text={'View Info'}
				sizing="Medium"
				full
				ghost
				maxWidth="110"
				// submit={handleCancel}
			/> */}
			<Button
				text={'Use Template'}
				sizing="Medium"
				full
				type="submit"
				submit={() => {
					goTo(`/eclip/create?templateId=${item.id}`)
				}}
			/>
			</div>
		</div>
	)
}
